<div
    class="agpr-themeAnalyticsSummary"
>
    <!-- Cards -->
    <div class="agpr-themeAnalyticsSummary-row" [id]="id + '.summary' + '.smallChart-top'">
        <agpr-card-chart
            class="agpr-themeAnalyticsSummary-smallChart-top"
            [series]="[totalVolumeSeries, previousPeriodTotalVolumeSeries]"
            [color]="cardChartComponentHighlightColorEnum.volume"
            [bubbleTooltipMetric]="socialMetrics.VOLUME"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
        <agpr-card-chart
            class="agpr-themeAnalyticsSummary-smallChart-top"
            [series]="[totalImpressionsSeries, previousPeriodTotalImpressionsSeries]"
            [color]="cardChartComponentHighlightColorEnum.impressions"
            [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
        <agpr-card-chart
            class="agpr-themeAnalyticsSummary-smallChart-top"
            [series]="[totalEngagementsSeries, previousPeriodTotalEngagementsSeries]"
            [color]="cardChartComponentHighlightColorEnum.engagements"
            [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
            [hidePrevious]="isArchiveSearch"
            [disabled]="isArchiveSearch && !enableEngagementInsights"
            [tooltipIconInfo]="(isArchiveSearch && !enableEngagementInsights) ? 'Social.agentWidget.archiveSearch.results.charts.noEngagement.tooltip': ''"
            headingLevel="4"
        >
        </agpr-card-chart>
    </div>

    <!-- Share of voice by social network -->
    <div
        *ngIf="shareOfVoiceBySocialNetwork"
        #shareOfVoiceBySocialNetworkChartElement
        class="agpr-themeAnalyticsSummary-chartContainer agpr-contextMenu-parent"
        [agprLoading]="shareOfVoiceBySocialNetworkLoading"
        [overlayStyleClass]="'agpr-themeAnalyticsSummary-chartLoading'"
        [id]="id + '.summary' + '.shareOfVoiceBySocialNetworkChart'"
    >
        <div class="agpr-themeAnalyticsSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="shareOfVoiceBySocialNetwork_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, shareOfVoiceBySocialNetworkChartElement, themeAnalyticsChartTypeEnum.SHARE_OF_VOICE_BY_SOCIAL_NETWORK_SUB)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart-group
            [charts]="shareOfVoiceBySocialNetwork"
            [showLoadingUntil]="chartLoadingOptionsEnum.none"
            [id]="id + '.summary.shareOfVoiceBySocialNetwork'"
        ></agpr-chart-group>
    </div>

    <!-- Summary by social network -->
    <div
        class="agpr-themeAnalyticsSummary-complexChartContainer agpr-contextMenu-parent"
        *ngIf="summaryBySocialNetworkChart"
        #summaryBySocialNetworkChartElement
        tabindex="0"
        [id]="id + '.summary' + '.complexCharts'"
    >
        <div class="agpr-themeAnalyticsSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="summaryBySocialNetworkChart_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="exportChart($event, summaryBySocialNetworkChartElement, themeAnalyticsChartTypeEnum.SUMMARY_BY_SOCIAL_NETWORK)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-themeAnalyticsSummary-complexChartContainerTitle">
            {{ 'Social.intelligence.themeAnalytics.summaryBySocialNetwork' | localize }}
        </h4>
        <agpr-network-radio
            class="agpr-themeAnalyticsSummary-complexChartContainerNetworkSelector"
            [availableNetworks]="enabledNetworkTypes"
            [defaultSelection]="networkTypeEnum.twitter"
            (selectedNetwork)="setSummaryBySocialNetworkSocialType($event)"
            [id]="'summaryBySocialNetwork_networkTypes'"
            [ariaLabel]="'Social.intelligence.themeAnalytics.engagement.socialNetworksLabel'"
        ></agpr-network-radio>
        <div class="agpr-themeAnalyticsSummary-complexChartContainerCharts">
            <div class="agpr-themeAnalyticsSummary-cardChartColumn">
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialNetworkVolumeSeries, previousPeriodSummaryBySocialNetworkVolumeSeries]"
                    [color]="cardChartComponentHighlightColorEnum.volume"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.NETWORK_VOLUME"
                    [hidePrevious]="isArchiveSearch"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialNetworkImpressionsSeries, previousPeriodSummaryBySocialNetworkImpressionsSeries]"
                    [color]="cardChartComponentHighlightColorEnum.impressions"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.NETWORK_IMPRESSIONS"
                    [hidePrevious]="isArchiveSearch"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialNetworkEngagementsSeries, previousPeriodSummaryBySocialNetworkEngagementsSeries]"
                    [color]="cardChartComponentHighlightColorEnum.engagements"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.NETWORK_ENGAGEMENTS"
                    [hidePrevious]="isArchiveSearch"
                    [disabled]="isArchiveSearch && !enableEngagementInsights"
                    [tooltipIconInfo]="(isArchiveSearch && !enableEngagementInsights) ? 'Social.agentWidget.archiveSearch.results.charts.noEngagement.tooltip': ''"
                >
                </agpr-card-chart>
            </div>
            <div class="agpr-themeAnalyticsSummary-complexChartContainerLarge">
                <agpr-chart
                    class="agpr-themeAnalyticsSummary-summaryBySocialNetwork"
                    [chart]="summaryBySocialNetworkChart"
                ></agpr-chart>
            </div>
        </div>
    </div>
    <label id="summary-label" for="parent" class="u-srOnly">hello</label>

    <!-- Share of voice by social topic -->
    <div
        *ngIf="shareOfVoiceBySocialTopic && !isArchiveSearch"
        class="agpr-themeAnalyticsSummary-chartContainer agpr-contextMenu-parent"
        #shareOfVoiceBySocialTopicChartElement
        [id]="id + '.summary' + '.shareOfVoiceBySocialTopicChart'"
    >
        <div class="agpr-themeAnalyticsSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="shareOfVoiceBySocialTopic_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, shareOfVoiceBySocialTopicChartElement, themeAnalyticsChartTypeEnum.SHARE_OF_VOICE_BY_SOCIAL_TOPIC_SUB)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart-group
            [charts]="shareOfVoiceBySocialTopic"
            [id]="id + '.summary.shareOfVoiceBySocialTopic'"
        ></agpr-chart-group>
    </div>

    <!-- Summary by social topic -->
    <div
        *ngIf="!isArchiveSearch"
        #summaryBySocialTopicChartElement
        class="agpr-themeAnalyticsSummary-complexChartContainer agpr-contextMenu-parent agpr-themeAnalyticsSummary-complexChartContainer--custom"
    >
        <div class="agpr-themeAnalyticsSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="summaryBySocialTopic_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="exportChart($event, summaryBySocialTopicChartElement, themeAnalyticsChartTypeEnum.SUMMARY_BY_SOCIAL_TOPIC)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-themeAnalyticsSummary-complexChartContainerTitleNoNetworkSelector">
            {{ 'Social.intelligence.themeAnalytics.summaryBySocialTopic' | localize }}
            <agpr-dropdown
                class="agpr-themeAnalyticsSummary-complexChartContainerDropdown"
                [style]="dropdownTypes.borderless"
                [agprStyle]="agprComponentStyle.social"
                [options]="summaryBySocialTopicDropdownOptions"
                ariaLabel="Social.intelligence.themeAnalytics.summaryBySocialTopicDropdown"
                [(ngModel)]="summaryBySocialTopicSelection"
                (ngModelChange)="onSummaryBySocialTopicSelectionChanged()"
                panelStyleClass="agpr-dropdown-panelSocial"
            ></agpr-dropdown>
        </h4>
        <div class="agpr-themeAnalyticsSummary-complexChartContainerCharts">
            <div class="agpr-themeAnalyticsSummary-cardChartColumn">
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialTopicVolumeSeries, previousPeriodSummaryBySocialTopicVolumeSeries]"
                    [color]="cardChartComponentHighlightColorEnum.volume"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.VOLUME"
                    [hidePrevious]="isArchiveSearch"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialTopicImpressionsSeries, previousPeriodSummaryBySocialTopicImpressionsSeries]"
                    [color]="cardChartComponentHighlightColorEnum.impressions"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
                    [hidePrevious]="isArchiveSearch"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeAnalyticsSummary-smallChart"
                    [series]="[summaryBySocialTopicEngagementsSeries, previousPeriodSummaryBySocialTopicEngagementsSeries]"
                    [color]="cardChartComponentHighlightColorEnum.engagements"
                    [layout]="cardChartComponentLayoutEnum.vertical"
                    [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
                    [hidePrevious]="isArchiveSearch"
                >
                </agpr-card-chart>
            </div>
            <div class="agpr-themeAnalyticsSummary-complexChartContainerLarge">
                <agpr-chart
                    class="agpr-themeAnalyticsSummary-summaryBySocialTopic"
                    [chart]="summaryBySocialTopicChart"
                ></agpr-chart>
            </div>
        </div>
    </div>

    <!-- Sentiment summary -->
    <div
        #sentimentSummaryChartElement
        class="agpr-themeAnalyticsSummary-chartContainer agpr-contextMenu-parent"
        [id]="id + '.summary' + '.sentimentChart'"
    >
        <div class="agpr-themeAnalyticsSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="sentimentSummary_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentSummaryChartElement, themeAnalyticsChartTypeEnum.SENTIMENT_SUMMARY)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart *ngIf="sentimentSummaryChart" [chart]="sentimentSummaryChart"></agpr-chart>
        <div #sentimentSummaryChartLegend class="agpr-themAnalyticsSummary-customLegendContainer"></div>
    </div>

    <!-- Top posts -->
    <div
        *ngIf="topPostsSeries"
        class="agpr-themeAnalyticsSummary-chartContainer"
        tabindex="0"
        [aria-label]="'Social.intelligence.themeAnalytics.topPostSummary' | localize"
        [id]="id + '.summary' + '.topPostsSeries'"
    >
        <agpr-top-posts
            [id]="id + '.summaryTopPosts'"
            [availableNetworkTypes]="enabledNetworkTypes"
            [series]="topPostsSeries"
            [sortIndex]="1"
            [enableEngagementInsights]="!isArchiveSearch || (isArchiveSearch && enableEngagementInsights)"
        >
        </agpr-top-posts>
    </div>
</div>
